/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green = high points, Red = low`)
};

const es_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verde = puntos altos, Rojo = bajos`)
};

const de_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grün = hohe Punkte, Rot = niedrig`)
};

const nl_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groen = veel punten, Rood = weinig`)
};

const fr_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vert = beaucoup de points, Rouge = peu`)
};

const it_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verde = punteggio alto, Rosso = basso`)
};

const pt_br2_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verde = alta pontuação, Vermelho = baixa`)
};

const pt_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verde = muitos pontos, Vermelho = poucos`)
};

const ja_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グリーン = 高ポイント、レッド = 低ポイント`)
};

const zh_f1_profile_tooltip_consistency_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绿色 = 高分，红色 = 低分`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_consistency_constructor = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_consistency_constructor(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_consistency_constructor", locale)
	if (locale === "en") return en_f1_profile_tooltip_consistency_constructor(inputs)
	if (locale === "es") return es_f1_profile_tooltip_consistency_constructor(inputs)
	if (locale === "de") return de_f1_profile_tooltip_consistency_constructor(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_consistency_constructor(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_consistency_constructor(inputs)
	if (locale === "it") return it_f1_profile_tooltip_consistency_constructor(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_consistency_constructor(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_consistency_constructor(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_consistency_constructor(inputs)
	return zh_f1_profile_tooltip_consistency_constructor(inputs)
};